<template>
	<!-- 分配专家 -->
	<div>
		<el-table :header-cell-style="tableStyle" border ref="multipleTable" :data="topicList" style="width: 100%">
			<el-table-column prop="name" label="评审组名称"></el-table-column>
			<el-table-column prop="num" label="待评数量"></el-table-column>
			<el-table-column prop="groupMembersName" label="评审专家" width="500"></el-table-column>
			<el-table-column prop="projectUnitName" label="操作">
				<template v-slot:default="scope">
					<el-button type="text" @click="rowBtn(scope.row, 0)" v-if="flow < 5">选择专家</el-button>
					<el-button type="text" @click="delBtn(scope.row, 1)" v-if="flow < 5">移出专家</el-button>
				</template>
			</el-table-column>
		</el-table>
		<!-- 保存并下一步 -->
		<div class="text-center" style="margin-top: 20px;"><button type="button" class="btn btn-info" @click="submitGroupForm" v-if="flow < 5">保存并下一步</button></div>
		<el-dialog title="邀请评审专家" :visible.sync="dialogVisible" width="50%" :before-close="handleClose">
			<div class="dia-nav clo-ter">
				<div class="clo-ter">
					<span class="col-tit">姓名：</span>
					<el-input v-model="selectObj.realName" clearable></el-input>
				</div>
				<div class="clo-ter" style="margin-left: 20px;">
					<span class="col-tit">学校：</span>
					<el-input v-model="selectObj.unitName" clearable></el-input>
				</div>
				<el-button type="primary" style="margin-left: 20px;" @click="getSelectUser">查询</el-button>
			</div>
			<!-- 表格 -->
			<el-table
				:header-cell-style="tableStyle"
				border
				ref="multipleTable"
				:data="reviewList"
				tooltip-effect="dark"
				style="width: 100%"
				@selection-change="mulSelectionChange"
			>
				<el-table-column type="selection" width="55" label="选择"></el-table-column>
				<el-table-column prop="realName" label="姓名" width="200"></el-table-column>
				<el-table-column prop="sex" label="性别" width="80">
					<template v-slot:default="scope">
						{{ scope.row.sex == 0 ? '女' : '男' }}
					</template>
				</el-table-column>
				<el-table-column prop="unitName" label="单位"></el-table-column>
			</el-table>
			<div class="pagination" style=" margin-top: 20px;display: flex;justify-content: center;">
				<el-pagination
					@size-change="handleSizeChange"
					@current-change="handleCurrentChange"
					:current-page="selectObj.pageNumber"
					:page-sizes="[50, 100, 200]"
					:page-size="selectObj.pageSize"
					layout="total, sizes, prev, pager, next, jumper"
					:total="underStudyTopicTotal"
				></el-pagination>
			</div>
			<span slot="footer" class="dialog-footer">
				<el-button type="primary" @click="submitBtn">{{ diaType == 0 ? '添加' : '移除' }}</el-button>
			</span>
		</el-dialog>
	</div>
</template>

<script>
import { settingGroup, userGetPageList, addSettingGroup, getReviewInfo } from '@/api/after/newInterface.js';
export default {
	data() {
		return {
			tableStyle: {
				textAlign: 'center',
				backgroundColor: '#7e9be2',
				color: '#fff'
			},
			topicList: [],
			dialogVisible: false,
			reviewList: [], //弹窗数据
			mulSelectVal: [], //弹窗多选
			selectObj: {
				realName: '',
				unitName: '',
				pageNumber: 1,
				pageSize: 20,
				roleId1: 3,
				userIds: null,
				row: null
			},
			underStudyTopicTotal: 10,
			projectId: null,
			rowId: null,
			diaType: 0,
			flow: null
		};
	},
	mounted() {
		this.projectId = sessionStorage.getItem('projectId');
		this.selectObj.row = sessionStorage.getItem('projectId');
		this.getUserList();
		this.getState();
	},
	methods: {
		getState() {
			getReviewInfo(this.projectId).then(res => {
				this.flow = res.data.flow;
			});
		},
		// 保存并下一步
		submitGroupForm() {
			this.$emit('finishBtn', 4);
		},
		delBtn(row, type) {
			this.diaType = type;
			this.dialogVisible = true;
			this.rowId = row.id;
			if (row.groupMembersId) {
				this.selectObj.userIds = row.groupMembersId;
			}
			this.getSelectUser();
		},
		submitBtn() {
			if (this.mulSelectVal.length > 0) {
				if (this.diaType == 0) {
					let name = this.mulSelectVal.map(item => item.realName).join(',');
					let id = this.mulSelectVal.map(item => item.id).join(',');
					addSettingGroup({ groupMembersId: id, groupMembersName: name, id: this.rowId, userIds: this.selectObj.userIds }).then(res => {
						if (res.code == 200) {
							this.$message.success(res.msg);
							this.dialogVisible = false;
							this.getUserList();
						} else {
							this.$message.error(res.msg);
						}
					});
				} else {
					let groupMembersName;
					let groupMembersId;
					if (this.topicList.length > 0) {
						groupMembersName = this.topicList.filter(item => item.id == this.rowId)[0].groupMembersName.split(',');
						groupMembersId = this.topicList
							.filter(item => item.id == this.rowId)[0]
							.groupMembersId.split(',')
							.map(Number);
					}

					let mulId = this.mulSelectVal.map(item => item.id);
					let userId = groupMembersId.filter(item => !mulId.includes(item)).join(',');

					let nulName = this.mulSelectVal.map(item => item.realName);
					let userName = groupMembersName.filter(item => !nulName.includes(item)).join(',');
					addSettingGroup({ id: this.rowId, groupMembersName: userName, groupMembersId: userId }).then(res => {
						if (res.code == 200) {
							this.$message.success(res.msg);
							this.dialogVisible = false;
							this.getUserList();
						} else {
							this.$message.error(res.msg);
						}
					});
				}
			} else {
				this.$message.warning('请勾选数据');
			}
		},
		rowBtn(row, type) {
			this.diaType = type;
			this.dialogVisible = true;
			this.rowId = row.id;
			this.selectObj.userIds = null;
			this.getSelectUser();
		},
		getSelectUser() {
			userGetPageList(this.selectObj).then(res => {
				if (res.code == 200) {
					this.reviewList = res.data.records;
					this.underStudyTopicTotal = res.data.total;
				} else {
					this.$message.error(res.msg);
				}
			});
		},
		handleSizeChange(val) {
			this.selectObj.pageSize = val;
			this.getSelectUser();
		},
		handleCurrentChange(val) {
			this.selectObj.pageNumber = val;
			this.getSelectUser();
		},
		getUserList() {
			settingGroup(this.projectId).then(res => {
				if (res.code == 200) {
					this.topicList = res.data;
				} else {
					this.$message.error(res.msg);
				}
			});
		},
		handleClose(done) {
			this.$confirm('确认关闭？')
				.then(_ => {
					done();
				})
				.catch(_ => {});
		},
		// 课题表格多选
		mulSelectionChange(val) {
			this.mulSelectVal = val;
		}
	}
};
</script>

<style scoped lang="scss">
.clo-ter {
	display: flex;
	align-items: center;
}
.dia-nav {
	margin-bottom: 20px;
}
.col-tit {
	color: #7e9be2;
	min-width: max-content;
}
</style>
